import gql from 'graphql-tag'
import { EntityFields } from '..'

export const YearFragment = gql`
  fragment Year on vehicle_year {
    ${EntityFields}
  }
`
